import React from 'react';
import { motion } from 'framer-motion';

const TrustSection = () => {
  const mediaLogos = [
    {
      src: "https://app1.sharemyimage.com/2025/08/18/cdnlogo.com_business-insider.png",
      alt: "Business Insider",
      className: "h-8"
    },
    {
      src: "https://app1.sharemyimage.com/2025/08/18/png-clipart-logo-forbes-industry-magazine-black-cover-company-text.png",
      alt: "Forbes",
      className: "h-8"
    },
    {
      src: "https://app1.sharemyimage.com/2025/08/18/FORTUNE-LOGO-2016.png",
      alt: "Fortune",
      className: "h-8"
    },
    {
      src: "https://app1.sharemyimage.com/2025/08/18/603-6035540_yahoo-finance-logo-png-transparent-png.png",
      alt: "Yahoo Finance",
      className: "h-8"
    }
  ];

  return (
    <section className="py-16 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Ethos Logo Prominently Featured */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-sm font-medium text-gray-500 mb-4 uppercase tracking-wide">
            Get Coverage Through
          </p>
          <div className="flex justify-center mb-6">
            <img 
              src="https://app1.sharemyimage.com/2025/08/18/ethos-logo_RGB_cypress.jpg" 
              alt="Ethos Life Insurance" 
              className="h-12 object-contain" 
            />
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            America's fastest-growing digital life insurance company, trusted by over 100,000 families
          </p>
        </motion.div>

        {/* Media Mentions */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <p className="text-sm font-medium text-gray-500 mb-8 uppercase tracking-wide">
            Trusted by Leading Publications
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center opacity-70 hover:opacity-100 transition-opacity duration-300">
            {mediaLogos.map((logo, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.1 * index, duration: 0.5 }}
                viewport={{ once: true }}
                className="flex items-center justify-center"
              >
                <img 
                  src={logo.src} 
                  alt={logo.alt} 
                  className={`${logo.className} object-contain filter grayscale hover:grayscale-0 transition-all duration-300`}
                />
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Trust Badges */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16"
        >
          <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl">
            <div className="text-3xl font-bold text-primary-600 mb-2">$2B+</div>
            <p className="text-gray-600">Coverage Delivered</p>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl">
            <div className="text-3xl font-bold text-accent-600 mb-2">100K+</div>
            <p className="text-gray-600">Families Protected</p>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-purple-50 to-violet-50 rounded-2xl">
            <div className="text-3xl font-bold text-purple-600 mb-2">A+ Rating</div>
            <p className="text-gray-600">Financial Strength</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustSection;